module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveCompany($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Idioma del administrador")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.languages,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "label": "Idiomas",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.language_id),
      callback: function($$v) {
        _vm.model.language_id = $$v
      },
      expression: "model.language_id"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "body-border-right": "",
      "pr-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Nombre de empresa")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Nombre de empresa"
    },
    model: {
      value: (_vm.model.company_name),
      callback: function($$v) {
        _vm.model.company_name = $$v
      },
      expression: "model.company_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Dirección")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Dirección"
    },
    model: {
      value: (_vm.model.address),
      callback: function($$v) {
        _vm.model.address = $$v
      },
      expression: "model.address"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "pb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Correo electrónico")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "email",
      "placeholder": "Nombre de empresa"
    },
    model: {
      value: (_vm.model.email),
      callback: function($$v) {
        _vm.model.email = $$v
      },
      expression: "model.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pl-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Número tributario")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "number",
      "placeholder": "Número tributario"
    },
    model: {
      value: (_vm.model.ruc),
      callback: function($$v) {
        _vm.model.ruc = $$v
      },
      expression: "model.ruc"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("País")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Ciudad")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "label": "País",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.cms_country_id),
      callback: function($$v) {
        _vm.model.cms_country_id = $$v
      },
      expression: "model.cms_country_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.citiesByCountry,
      "item-text": "name",
      "item-value": "id",
      "disabled": !_vm.model.cms_country_id,
      "hide-details": "",
      "label": "Ciudad",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.city_id),
      callback: function($$v) {
        _vm.model.city_id = $$v
      },
      expression: "model.city_id"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "pb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Web")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Dirección web"
    },
    model: {
      value: (_vm.model.website),
      callback: function($$v) {
        _vm.model.website = $$v
      },
      expression: "model.website"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "body-border-top": "",
      "body-border-bottom": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "body-border-right": "",
      "pr-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "pb-3": "",
      "pt-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Datos del contacto")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Nombre del contacto"
    },
    model: {
      value: (_vm.model.contact_name),
      callback: function($$v) {
        _vm.model.contact_name = $$v
      },
      expression: "model.contact_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pl-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pb-3": "",
      "pt-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Correo electrónico")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Teléfono")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "email",
      "placeholder": "Correo electrónico"
    },
    model: {
      value: (_vm.model.contact_email),
      callback: function($$v) {
        _vm.model.contact_email = $$v
      },
      expression: "model.contact_email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "phone",
      "placeholder": "Teléfono"
    },
    model: {
      value: (_vm.model.phone),
      callback: function($$v) {
        _vm.model.phone = $$v
      },
      expression: "model.phone"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Logo de la compañía")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pr-3": ""
    }
  }, [_c('file-upload-container', {
    attrs: {
      "image-url": _vm.model.url_image,
      "label-for": 'company-logo',
      "max-resolution": _vm.maxResolution,
      "min-resolution": _vm.minResolution
    },
    on: {
      "upload": _vm.onUpload
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "title-form pt-0 mb-0"
  }, [_vm._v("Elegir los idiomas que aparecerán en los módulos")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.languages), function(language) {
    return _c('v-flex', {
      key: language.id,
      attrs: {
        "md2": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "input-checkbox input-languages",
      attrs: {
        "value": language.id,
        "hide-details": ""
      },
      model: {
        value: (_vm.model.language_json),
        callback: function($$v) {
          _vm.model.language_json = $$v
        },
        expression: "model.language_json"
      }
    }, [_c('template', {
      slot: "label"
    }, [_c('img', {
      attrs: {
        "src": language.url_image,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(language.name))])])], 2)], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n\t\t\t\t\tGuardar\n\t\t\t\t")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45fba50a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/configuration/Company.vue
// module id = 1628
// module chunks = 51